if (process.env.NODE_ENV !== 'production') {
  import('./devImports.js')
}
import Vue from 'vue'
import App from './App.vue'
import store from './store';
import TagManager from './services/TagManager'


Vue.prototype.$gtag = TagManager.init(process.env.NODE_ENV);

Vue.config.productionTip = false;
new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
